/**
 * Created by yibrahim on 20/07/2017.
 */
import {ReasonCode} from './reason-code';
import {RefundReason} from './refund-reason';
import {Currency} from './currency';
import {TravelCreditType} from './travel-credit-type';

export class Credit {
  constructor(public reasonCode: ReasonCode = null,
              public refundReason: RefundReason = null,
              public currency: Currency = null,
              public fareMasked: boolean = false,
              public feeAmountWaived: string = null,
              public valueWaived: string = null,
              public travelCreditType: TravelCreditType = null)
  {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/credit.ts